<div class="partner-header-container" [ngStyle]="{'background-image': 'url(' + 'https:' + sponsorOnboardingCMSData?.onboardingBackgroundImage.fields.file.url + ')'}">
    <div class="partner-header-content">
        <div class="partner-logo">
            <img class="logo" [src]="'https:' + sponsorOnboardingCMSData?.onboardingSponsorLogo.fields.file.url" alt="partner-logo">
        </div>
        <div class="partner-details">
            <div class="partner-desc">
                {{sponsorOnboardingCMSData?.sponsorWelcomeText}}
            </div>
            <div class="powered-by">
                <span>powered by</span> <span class="gravty"> GRAVTY </span>
            </div>
        </div>
    </div>
</div>
